
export const loadStyle = (styleName: string, elementId: string) => {
	const head = document.getElementsByTagName('head')[0];

	const themeLink = document.getElementById(
		elementId
	) as HTMLLinkElement;
	if (themeLink) {
		themeLink.href = styleName;
	} else {
		const style = document.createElement('link');
		style.id = elementId;
		style.rel = 'stylesheet';
		style.href = `${styleName}`;
		head.appendChild(style);
	}
}